import { Image, UIHeading4, UIHeading5, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './OfferSuggestion.css';

interface IOfferSuggestionProps {
  title?: string | null;
  subtitle?: string | null;
  caption?: string | null;
  deeplink: string;
  imageUrl: string;
  info?: string | null;
  logoUrl?: string | null;
  id: number;
  onClick: () => void;
}

export const OfferSuggestion: React.FC<IOfferSuggestionProps> = ({
  caption,
  deeplink,
  imageUrl,
  info,
  logoUrl,
  onClick,
  subtitle,
  title,
}) => {
  return (
    <li className={styles['container']}>
      <a href={deeplink} onClick={onClick} className={styles['link']}>
        {logoUrl && <img src={logoUrl} className={styles['logo']} width="32px" height="32px" />}
        <Image src={imageUrl} width="100%" height="126px" preloader={false} objectFit="cover" borderRadius={0} />
        <div className={styles['content']}>
          <span className={styles['title']}>
            <UIHeading4>{title}</UIHeading4>
          </span>
          {subtitle && <UIHeading5>{subtitle}</UIHeading5>}
          {info && (
            <span className={styles['info']}>
              <UIText2>{info}</UIText2>
            </span>
          )}
          {caption && (
            <span className={styles['caption']}>
              <UIText2 color="text-secondary-default">{caption}</UIText2>
            </span>
          )}
        </div>
      </a>
    </li>
  );
};
